import styles from './ComingSoon.module.css';

const ComingSoon = () => {
  return (
    <div className={styles.maintenanceContainer}>
      <div className={styles.statusBadge}>Phase 2 Development</div>

      <h1 className={styles.mainTitle}>Building your <br /><span>Financial Hub</span></h1>

      <p className={styles.description}>
        We’re currently fine-tuning our App.
        The Expense Tracker will be back online shortly.
      </p>

      <div className={styles.progressBar}>
        <div className={styles.progressFill} style={{ width: '75%' }}></div>
      </div>
      <span className={styles.progressText}>75% Complete</span>

      <form className={styles.notifyBox}>
        <input type="email" placeholder="Email address" required />
        <button type="submit">Get Early Access</button>
      </form>
      

      <div className={styles.footer}>
        <a href="/support" className={styles.cleanLink}>Contact Support</a>
      </div>
    </div>

  );
};

export default ComingSoon;